export default {"src":"https://cdn.jetlend.ru/_next/static/media/department-marketing.c4c41308.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};